





















import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import { delCookie, getCookie } from "@/JS/cookie"; //使用getCookie方法
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import Bus from "@/JS/Bus";
import httpApi from "@/API/Tenant/Weixin";

import list from "./list.vue"; //表单列表
import add from "./add.vue";

@Component({
  components: {
    list,
    add
  }
})
export default class extends Vue {
  @Provide() activeName: string = "listForm"; //当前选中tab的name
  @Provide() sliderMenu: any = [];
  @Provide() formList: any = []; //新增表单数据；
  @Provide() formObj: any = null; //修改的表单数据;
  @Provide() formIndex: any = null; //修改表单的下标;

  //初始化
  async created() {
    var content = this;
    this.LoadGetformList();
    this.$on("defaultModule", function(msg: any) {
      content.activeName = msg;
    });
  }
  //加载列表数据
  async LoadGetformList() {
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: { TenantID: getCookie("TenantID") }
        }
      ]
    };
    var res: any = await httpApi.GetSmartFormMainListAsync(params);
    console.log(res);
    if (res.ErrorCode == 0) {
      this.formList = res.output[0].value;
    } else {
      this.$message.error("取列表失败：" + res.ErrorMessage);
    }
  }
  //保存数据
  async addModifyForm(formData: any) {
    console.log(formData);

    let that = this;
    that.activeName = formData.pagename;
    // 修改保存
    if (formData.pageindex && formData.pageinfo) {
      that.formList[formData.pageindex] = formData.pageinfo;
    }
    // 修改传参
    if (formData.pageinfo == null && formData.pageindex != null) {
      that.formObj = that.formList[formData.pageindex];
      that.formIndex = formData.pageindex;
    }
    // 新建保存
    if (formData.pageinfo && formData.pageindex == null) {
      formData.pageinfo.SmartFormId = "";
    }
    // 新建
    if (formData.pageindex == null && formData.pageinfo == null) {
      this.formObj = null;
      this.formIndex = null;
    }
    //提交数据
    var model = formData.pageinfo;
    model.moduleList = JSON.stringify(model.moduleList);
    model.getTouSuAdmin = JSON.stringify(model.getTouSuAdmin);
    model.submitTime=JSON.stringify(model.submitTime);
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: model
        }
      ]
    };
    //console.log(params);
    var res: any = await httpApi.SaveSmartFormMainAsync(params); //console.log(res);
    if (res.ErrorCode == 0) {     
      this.$message.success("保存成功！");
    } else {
      this.$message.error("保存失败：" + res.ErrorMessage);
    }
    this.LoadGetformList();
  }
  addSysForm(sysFormData: any) {
    let that = this;
    that.activeName = sysFormData.pagename;
    this.formObj = sysFormData.pageinfo;
    this.formIndex = null;

  }
}
